module.exports = __webpack_public_path__ + "img/logo_3.8977078c.svg";